import(/* webpackMode: "eager" */ "/vercel/path0/app/clinic/(defaultLayout)/error.tsx");
